import { render } from "./PreSeeds.vue?vue&type=template&id=66e1488e"
import script from "./PreSeeds.vue?vue&type=script&lang=js"
export * from "./PreSeeds.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__